module.exports = __webpack_public_path__ + "img/main_bg.1377cce2.png";